var _launchUrlString = '/_launch_/';
/**
 * Launcher helper for Direct Launch Feature
 * https://confluence.sbtech.com/display/PI/Direct+Launch+of+Casino+Games+Widget
 * use this to be initiate launch from javascript event hanlers like click on bunner button and promotional page
 * @param app - Application object
 * @param casinoWidget - CasinoWidget object it global object exported on page once CasinoSDKBlock defined on this page
 * @param rsx - direct launch url in format of (/_launch/D##M##)
 */
export function launch(app, rsx) {
    if (typeof rsx !== 'string' || rsx.indexOf(_launchUrlString) === -1) {
        return;
    }
    if (!urlAtCurrentPage(app, rsx)) {
        window.location.href = rsx;
        return;
    }
    var sdk = typeof CasinoWidget === 'undefined' ? undefined : CasinoWidget.sdk();
    if (!sdk) {
        return;
    }
    sdk.startGame(rsx);
}
function urlAtCurrentPage(app, url) {
    if (url.lastIndexOf(_launchUrlString, 0) === 0) {
        return true;
    }
    var page = app.Navigation.pageNavigationConfig.FullPagePath;
    return page ? url.indexOf(page) !== -1 : false;
}
//# sourceMappingURL=Launch.js.map